import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/app/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class LabClientsService {
  endpoint:any;
  constructor(private http: HttpClient, private configService: ConfigService) {
    this.endpoint = this.configService.endpoints;
   }

  getLabclients(filterModel, customFilter) {
    return `${this.endpoint.APIEndpoint}/LabClient/list/labclients?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}&${customFilter}`;
  }

  getLabclientsInactiveClients() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/LabClient/list/InactiveClients`);
  }

  getSalesRep(filterModel) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/SalesRep/list?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}`);
  }

  saveLabClient(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/LabClientCollectors`, data);
  }

  updateLabClient(data) {
    return this.http.put<any>(`${this.endpoint.APIEndpoint}/LabClientCollectors`, data);
  }

  // api new
  updateLabClients(data) {
    return this.http.put<any>(`${this.endpoint.APIEndpoint}/LabClient`, data);
  }

  saveLabClients(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/LabClient`, data);
  }

  deleteLabClients(id) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/LabClient/${id}/disable`, null);
  }

  labClientEnable(id) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/LabClient/${id}/enable`, null);
  }

  labClientDisable(id) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/LabClient/${id}/disable`, null);
  }

  labClientById(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/LabClient/${id}`);
  }

  labClientCollectorById(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/LabClientCollectors/${id}`);
  }

  clientCollectors(clientId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/LabClientCollectors/list/${clientId}`);
  }

  saveLabClientCollector(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/LabClientCollectors`, data);
  }

  updateLabClientCollector(data) {
    return this.http.put<any>(`${this.endpoint.APIEndpoint}/LabClientCollectors`, data);
  }

  deleteLabClientCollector(id) {
    return this.http.delete<any>(`${this.endpoint.APIEndpoint}/LabClientCollectors/delete/${id}`);
  }

  getSalesReplist() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/SalesRep/list`);
  }

  salesRepClients(clientId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/SalesRepClients/list/LabClients/${clientId}`);
  }

  saveSalesRepClient(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/SalesRepClients`, data);
  }

  deleteSalesRepClient(id) {
    return this.http.delete<any>(`${this.endpoint.APIEndpoint}/SalesRepClients/delete/${id}`);
  }

  labClientlogs(id, filterModel, customFilter) {
    return `${this.endpoint.APIEndpoint}/LabClient/logs/${id}?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}&${customFilter}`;
  }

  getPatientlogs(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Patient/logs/list/${id}`);
  }

  getPhysicians(filterModel, customFilter) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/LabClient/list?${filterModel.PageSize}&${filterModel.RunCount}&${filterModel.StartPageNo}&${filterModel.SortExpression}&${customFilter}`);
  }

  getStateslookup() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Stateslookup/list/`);
  }

  getClinicalSetting() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/ClinicalSetting/list/`);
  }

  getLcdContractType() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/LcdContractType/list/`);
  }

  zipcodesLookup(zip) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/ZipcodesLookup/find/${zip}`);
  }

  getLabClientInventory(id) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/LabClientInventory/inventoriesByLocation/${id}`);
  }

  getLabClientInventoryRequests(locationId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/LabClientInventory/requests/${locationId}?PageSize=300&RunCount=true&sortExpression=`);
  }

  getBilling() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/BillingType/list`);
  }


}
